"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _followBook = require("../../api/followBook");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Type',
  data: function data() {
    return {
      data: undefined,
      totalPages: undefined,
      deleteLoading: false,
      loading: {
        list: false
      }
    };
  },
  computed: {
    bookListStyle: function bookListStyle() {
      return {
        height: "".concat(this.$store.state.app.availableHeight, "px")
      };
    } // 控制页面高度

  },
  mounted: function mounted() {
    this.updateList();
  },
  methods: {
    updateList: function () {
      var _updateList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading.list = true;
                _context.prev = 1;
                _context.next = 4;
                return this.getList();

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 10:
                _context.prev = 10;
                this.loading.list = false;
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6, 10, 13]]);
      }));

      function updateList() {
        return _updateList.apply(this, arguments);
      }

      return updateList;
    }(),
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$readTypeList, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _followBook.readTypeList)();

              case 3:
                _yield$readTypeList = _context2.sent;
                this.data = _yield$readTypeList.data;
                this.totalPages = _yield$readTypeList.totalPages;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                message = _context2.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }()
  }
};
exports.default = _default;